import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Make sure the file name matches the actual file

import { Amplify } from 'aws-amplify';
import config from './amplifyconfiguration.json'; // Adjust path as needed

// Ensure `custom:display_name` is included
config.Auth = {
  ...config.Auth,
  attributesToRetrieve: ['email', 'custom:display_name', 'sub'],
};

Amplify.configure(config);// Amplify configuration (run only once)

// Ensure that an element with the ID 'root' exists in your index.html file
const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found'); // Handle the case where the element doesn't exist

const root = ReactDOM.createRoot(rootElement);
root.render(
  <>
    <App />
  </>
);
